{% block swag_cms_extensions_form_element_config %}
    <div class="swag-cms-extensions-form-element-config">
        {% block swag_cms_extensions_form_element_config_form_select %}
            <sw-entity-single-select
                v-model:value="templateId"
                entity="swag_cms_extensions_form"
                labelProperty="technicalName"
                :placeholder="$tc('swag-cms-extensions.sw-cms.elements.custom-form.config.templateSelectPlaceholder')"
                :label="$tc('swag-cms-extensions.sw-cms.elements.custom-form.config.templateSelectLabel')"
                :criteria="formTemplateCriteria"
            />
        {% endblock %}

        {% block swag_cms_extensions_form_element_config_edit_form_link %}
            <a
                class="swag-cms-extensions-form-element-config__link"
                @click="openFormTemplateModal"
            >
                {{ $tc('swag-cms-extensions.sw-cms.elements.custom-form.config.editFormTemplateLink') }}

                {% block swag_cms_extensions_form_element_config_edit_form_link_icon %}
                    <mt-icon
                        class="swag-cms-extensions-form-element-config__link-icon"
                        name="regular-chevron-right-xs"
                    />
                {% endblock %}
            </a>
        {% endblock %}

        {% block swag_cms_extensions_form_element_config_edit_form_template_modal %}
            <swag-cms-extensions-form-template-modal
                v-if="showFormTemplateModal"
                @modal-close="closeFormTemplateModal"
                @template-updated="onTemplateUpdated"
            />
        {% endblock %}
    </div>
{% endblock %}
